import { ClientIdentityType } from 'api/types/data';

export const isPersonClient = (type: ClientIdentityType) =>
  type === ClientIdentityType.Client ||
  type === ClientIdentityType.ClientWithRepresentative;
